import { gray10, screenSmMin, screenXsMin } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
const TopTransition = styled.div `
  position: absolute;
  width: 200%;
  height: 200%;
  clip-path: ellipse(29% 100% at 25% 0%);
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
const BottomTransition = styled.div `
  display: flex;
  position: relative;
  overflow: hidden;
  height: 30px;
  width: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  align-items: flex-end;
  // 768px and above
  @media (min-width: ${screenSmMin}) {
    height: 104px;
  }
  // 480px and above
  @media (min-width: ${screenXsMin}) {
    height: 62px;
  }
`;
export const GraphicTransitionModule = (mod) => {
    var _a, _b;
    if (!mod.transitionColors) {
        return null;
    }
    return (React.createElement(BottomTransition, { backgroundColor: ((_a = mod.transitionColors) === null || _a === void 0 ? void 0 : _a.bottomColor) || gray10 },
        React.createElement(TopTransition, { active: true, backgroundColor: ((_b = mod.transitionColors) === null || _b === void 0 ? void 0 : _b.topColor) || gray10 })));
};
//# sourceMappingURL=index.js.map